import { Utils } from 'common';

const { Communication } = Utils;

export default class ContactsCommunication extends Communication {
	static init(params) {
		Communication.init(params);
	}

	static async searchContacts(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/search`,
			data,
		});
	}

	static async getContactData(contactId) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/contacts/${contactId}`,
		});
	}

	static async addContact(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts`,
			data,
		});
	}

	static async updateContact(data) {
		return this.axiosRequest({
			method: 'put',
			url: `${this.accountApiUrlPrefix}/contacts`,
			data,
		});
	}

	static async deleteContacts(data) {
		return this.axiosRequest({
			method: 'delete',
			url: `${this.accountApiUrlPrefix}/contacts`,
			data,
		});
	}

	static async getSelectedGroups(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/group/getselected`,
			data,
		});
	}

	static async addGroup(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/group`,
			data,
		});
	}

	static async renameGroup(data) {
		return this.axiosRequest({
			method: 'put',
			url: `${this.accountApiUrlPrefix}/contacts/group`,
			data,
		});
	}

	static async deleteGroup(groupId) {
		return this.axiosRequest({
			method: 'delete',
			url: `${this.accountApiUrlPrefix}/contacts/group/${groupId}`,
		});
	}

	static async groupAssociations(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/group/association`,
			data,
		});
	}

	static async costCodeAssociations(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/costcode/association`,
			data,
		});
	}

	static async getSelectedReferenceNumbers() {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/contacts/referencenumber`,
		});
	}

	static async referenceAssociations(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/referencenumber/association`,
			data,
		});
	}

	static async parseName(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/parsename`,
			data,
		});
	}

	static async getSavedTemplate(templateId) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/contacts/templates/${templateId}`,
		});
	}

	static async getSavedTemplates() {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/contacts/templates`,
		});
	}

	static async saveTemplate(data) {
		return this.axiosRequest({
			method: 'put',
			url: `${this.accountApiUrlPrefix}/contacts/templates`,
			data,
		});
	}

	static async importContact(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/import`,
			data,
		});
	}

	static async uploadFile(data) {
		const queryParams = `templateId=${data.templateId}&hasHeader=${data.hasHeader}&duplicateHandle=${data.duplicateHandle}&continueWithErrors=${data.continueWithErrors}&groupId=${data.groupId}`;
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/contacts/upload?${queryParams}`,
			data: data.fileData,
		});
	}

	// used for saving selected contacts data to send to Mail app
	static async saveSelectedContacts(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/misc/communicationdata/printpostagefromcontacts`,
			data,
		});
	}
}
